<div class="inicio">

    <p class="titulo">CATÁLOGO DE TIPOS DE SOLICITUDES</p>

  <!--TABLA CON LOS DATOS -->
      <div class="div"  >

          <!--Barra de búsqueda-->
          <div  class="grid-container2">
              <mat-form-field>
                  <mat-label>BUSCAR</mat-label>
                  <input matInput  (keyup)="applyFilter($event)"  placeholder="INGRESE DATO A BUSCAR">
              </mat-form-field>

          </div>

          <!--Boton Descargar reporte-->
          <div class="grid-container5">
              <button mat-raised-button style="background-color: #28e702;" (click)="this.banderaFormulario=true" > AGREGAR TIPO
                  <mat-icon> playlist_add </mat-icon>
              </button>&nbsp;
          </div>
          <!--FORMULARIO PARA AGREGAR UN TIPO-->
          <div class="divAddTipo" *ngIf="this.banderaFormulario==true" >
            <form #insertForm="ngForm" [formGroup]="formTipoSolicitud" >

              <div class="grid-container2"  >
                <div class="celda"  >
                  <mat-label class="label">Tipo de solicitud</mat-label>
                  <mat-select placeholder="Selecciona el tipo de solicitud"  formControlName="tipoSolicitud"   required >
                    <mat-option *ngFor="let tipo of listaTiposSoli" [value]=tipo >{{ tipo }} </mat-option>
                  </mat-select>
                </div>
                <div class="celda" >
                  <mat-label class="label"> Estatus  </mat-label>
                  <mat-select placeholder="Seleccione el estatus"  formControlName="status"   required >
                    <mat-option *ngFor="let status of listaStatus" [value]=status>{{ status }} </mat-option>
                  </mat-select>
                </div>
              </div>
              <div class="grid-container" >
                <div class="celda" >
                  <mat-label class="label"> Descripción </mat-label>
                  <mat-form-field appearance="outline">
                    <input matInput type="text" placeholder="Descripción del tipo de solicitud"  formControlName="descripcion" oninput="this.value = this.value.toUpperCase()" />
                  </mat-form-field>
                </div>
              </div>
              <div class="wrapper">
                <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar" (click)="editarTipoSolicitud()" >Editar <span class="material-icons">edit</span> </button>
                <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar==false" (click)="agregarTipoSolicitud()" >Agregar <span class="material-icons">done</span> </button>
                <br><br>
                <button mat-raised-button style="background-color: #fd4545;" (click)="this.limpiarFormulario()" >Cancelar <mat-icon>cancel</mat-icon> </button>
              </div>
            </form>
          </div>

          <!--Tabla-->
          <table mat-table [dataSource] = "dataSource"  class="mat-elevation-z8">

              <!-- Position Column -->
              <ng-container matColumnDef="editar">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> EDITAR </th>
                  <td mat-cell *matCellDef="let element">
                      <button mat-mini-fab style="background-color: #0804e9;" (click)="mostrarTipoSolicitud(element.id_tipo_solicitud_usuario)"> <span class="material-icons">edit</span> </button>
                  </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="tipo_solicitud">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
                  <td mat-cell *matCellDef="let element"> {{element.tipo_solicitud}} </td>
              </ng-container>
              <ng-container matColumnDef="status_solicitud">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS  </th>
                <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
              </ng-container>
              <ng-container matColumnDef="descripcion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> DESCRIPCIÓN </th>
                <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="fecha_creacion">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE CREACIÓN </th>
                  <td mat-cell *matCellDef="let element"> {{element.fecha_creacion.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="fecha_mod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA DE MODIFICACIÓN </th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_mod.substring(0,10)}} </td>
            </ng-container>


              <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

          </table>
          <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

    </div>



</div>
